import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes improvisaba todos los días… ahora tengo todo listo y mis clases fluyen solas.',
  name: 'Laura M.',
  role: 'Docente inicial'
}, {
  quote: 'Mis alumnos están más tranquilos, participan más y yo dejo de gritar.',
  name: 'Carla R.',
  role: 'Jardín'
}, {
  quote: 'Por fin tengo mis fines de semana libres. Todo está tan bien estructurado que solo aplico y listo.',
  name: 'Ana G.',
  role: 'Kínder, México'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-276">
      <div className="max-w-xl mx-auto" data-id="element-277">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-278">
          💬 ¿Qué dicen las maestras que ya usan el Megapack?
        </h2>

        <div className="space-y-4" data-id="element-279">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-5 rounded-xl" data-id="element-280">
              <div className="flex gap-0.5 mb-3" data-id="element-281">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-282" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-283">
                "{t.quote}"
              </p>
              <div data-id="element-284">
                <p className="font-bold text-white text-sm" data-id="element-285">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-286">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}